// @section 1 Clients shell — post-win client work.
//
// Companion to /pipeline (prospect→won kanban). Once a deal hits Won, the
// account belongs HERE: engagement scope, workstreams, deliverables, reviews.
//
//   /clients              → PortfolioView (default)
//   /clients/:clientId    → ClientDetail (per-client workspace)
//
// Scaffolded 2026-06-06. Data layer is intentionally thin; cleanup of the
// underlying hq_delivery + hq_crm rows comes after the module ships.

import { Route, Routes } from 'react-router-dom';
import PortfolioView from './PortfolioView';
import ClientDetail from './ClientDetail';
import { useIsMobile } from '../../lib/useIsMobile';

// @subsection 1.1 Shell

export default function ClientsShell() {
  // @block 1.2 Phone: the shell owns the scroll for both child routes (the
  // roster table and the per-client detail) since the canvas is overflow:hidden.
  const isMobile = useIsMobile();
  return (
    <div style={isMobile
      ? { display: 'flex', flexDirection: 'column', height: '100%', overflowY: 'auto', WebkitOverflowScrolling: 'touch' }
      : { display: 'flex', flexDirection: 'column', minHeight: 0, flex: 1 }}>
      <Routes>
        <Route index element={<PortfolioView />} />
        <Route path=":clientId" element={<ClientDetail />} />
      </Routes>
    </div>
  );
}
